import request from '../request';

type RequestData = {
  bookingId: string;
};

const getOTP = async (body: RequestData, signal?: AbortSignal) => {
  const result = await request<void, RequestData>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/bookings/${body?.bookingId}/otp`,
    method: 'GET',
    signal,
  });

  return result;
};

export default getOTP;
